export enum OmnisearchEntity {
  profiles = 'profiles',
  solicitationExperts = 'solicitationExperts',
  opportunities = 'opportunities',
  clients = 'clients',
}

/** returned fields may be empty strings if no value on profile */
export interface IOmnisearchProfile {
  entity: OmnisearchEntity.profiles;
  id: string;
  name: string;
  nameHighlight: string;
  matchedEmail: string;
  matchedEmailHighlight: string;
  matchedPhoneNumber: string;
  matchedPhoneNumberHighlight: string;
  lastEvent: string;
  relevance: number;
  geographicTarget: string;
}

export interface IOmnisearchSolicitationExpert {
  id: string;
  entity: OmnisearchEntity.solicitationExperts;
  name: string;
  emailAddress: string;
  allEmails: string[];
  oppId: string;
  oppName: string;
  clientId: string;
  profileType: string;
  geographicTarget: string;
}

export interface IOmnisearchClient {
  id: string;
  entity: OmnisearchEntity.clients;
  name: string;
}

export interface IOmnisearchOpportunity {
  id: string;
  entity: OmnisearchEntity.opportunities;
  name: string;
  publicDisplayId: string;
  clientId: string;
  omnisearchHidden: boolean;
  onHold: boolean;
  opportunityAssigneeIds: string[];
}

export interface IOmnisearchProfileResponse {
  profiles: (Omit<IOmnisearchProfile, 'entity' | 'id'> & {
    profileId: string;
  })[];
}

export type OmnisearchQueryResponse =
  | IOmnisearchProfile
  | IOmnisearchSolicitationExpert
  | IOmnisearchOpportunity
  | IOmnisearchClient;
